const date = (value) =>{
  if (value) {
    return moment(value).format('M/D/YYYY');
  }
  return '';
}

export default {
  date,
  time(value) {
    if (value) {
      return moment(value).format('HH:mm:ss');
    }
    return '';
  },





  gstDateFormat(value) {
    if (value) {
      return moment(value).format('YYYY-MM-DD');
    }
    return null;
  },


  stcDateFormat(value) {
    if (value) {
      return moment(value).format('MM/DD/YYYY');
    }
    return null;
  },

  getLocalTimeStamp(dateP, timeP){
    if (date)
      {
          const date = moment(dateP).endOf('d').toDate();
          var month = (date.getMonth() + 1).toString()
          if (month.length === 1)
          { month = '0' + month}
          var day = date.getDate().toString()
          if (day.length === 1)
          {day = '0' + day}
          return  date.getFullYear() + '-' + month + '-' + day + 'T' + timeP
      }
      else
      {
        return null
      }
},



  getLocalDate(item){
    if (item)
      {
        if (item == 'Invalid Date') return item;
          const date = moment(item).endOf('d').toDate();
          var month = (date.getMonth() + 1).toString()
          if (month.length === 1)
          { month = '0' + month}
          var day = date.getDate().toString()
          if (day.length === 1)
          {day = '0' + day}
          return  date.getFullYear() + '-' + month + '-' + day + 'T00:00:00'
      }
      else
      {
        return null
      }
},

getLocalDateOnly(item){
  if (item)
    {
      if (item == 'Invalid Date') return item;
        const date = moment(item).endOf('d').toDate();
        var month = (date.getMonth() + 1).toString()
        if (month.length === 1)
        { month = '0' + month}
        var day = date.getDate().toString()
        if (day.length === 1)
        {day = '0' + day}
        return  date.getFullYear() + '-' + month + '-' + day
    }
    else
    {
      return null
    }
},


getLocalDateNumber(item){
  if (item)
    {
      if (item == 'Invalid Date') return item;
        const date = moment(item).endOf('d').toDate();
        var month = (date.getMonth() + 1).toString()
        if (month.length === 1)
        { month = '0' + month}
        var day = date.getDate().toString()
        if (day.length === 1)
        {day = '0' + day}
        return  date.getFullYear() + month  + day
    }
    else
    {
      return null
    }
},





getLocalDateEnd(item){
  if (item)
    {
      if (item == 'Invalid Date') return item;
        const date = moment(item).endOf('d').toDate();
        var month = (date.getMonth() + 1).toString()
        if (month.length === 1)
        { month = '0' + month}
        var day = date.getDate().toString()
        if (day.length === 1)
        {day = '0' + day}
        return  date.getFullYear() + '-' + month + '-' + day + 'T23:59:59'
    }
    else
    {
      return null
    }
},


 

  gstDT(value, zone) {
    if (value) {
     
    return moment(value).format('M/D/YYYY HH:mm:ss');
    }
    return '';
},


  timeHHmm(value) {
    if (value) {
      return moment(value).format('HH:mm');
    }
    return '';
  },
  tz(value){
    if (value) {
      return moment.tz.zone(moment.tz.guess()).abbr(moment(value).format('x'));
    }
    return '';
  },
  tryDateFromExcel(value) {
    let parsedDate = moment(value, "M/D/YYYY").toDate();
    if (`${parsedDate}` === 'Invalid Date') {
      parsedDate = moment(value, 'YYYY-MM-DD').toDate();
    }
    return parsedDate;
  },
  weekDayDisplay(day){
    return moment().day(day).format('ddd');
  }
};
